import { __extends } from "tslib";
import cx from 'classnames';
import { noop } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Hotspot.module.css';
var HoverHotspot = /** @class */ (function (_super) {
    __extends(HoverHotspot, _super);
    function HoverHotspot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hotspotRef = React.createRef();
        return _this;
    }
    HoverHotspot.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, isVisible = _b.isVisible, left = _b.left, top = _b.top, width = _b.width, height = _b.height, hover = _b.hover;
        var style = { left: left, top: top, width: width, height: height };
        return (React.createElement("div", { className: cx(styles.hotspot, (_a = {}, _a[styles.visibleHotspot] = isVisible, _a)), onMouseOver: function (e) {
                var position = _this.hotspotRef.current.getBoundingClientRect();
                hover(e, {
                    top: position.top,
                    left: position.left,
                    right: position.right,
                    bottom: position.bottom,
                });
            }, ref: this.hotspotRef, style: style }));
    };
    return HoverHotspot;
}(React.Component));
export default HoverHotspot;
HoverHotspot.propTypes = {
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    isVisible: PropTypes.bool.isRequired,
    hover: PropTypes.func.isRequired,
};
HoverHotspot.defaultProps = {
    hover: noop,
};
